"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@emotion/core");
const theme_1 = require("@zapier/theme");
const design_system_1 = require("@zapier/design-system");
const react_1 = require("react");
const AuthBox_1 = __importDefault(require("../../sample/AuthBox"));
const lodash_1 = require("lodash");
const common_components_1 = require("@zapier/common-components");
const rootStyle = core_1.css `
  background-color: ${design_system_1.Colors.grey000};
  border-radius: 10px;
  display: flex;
  align-items: center;
  flex-direction: column;
  line-height: 25px;
  padding: 50px 30px;
  text-align: center;
`;
const headerStyle = core_1.css `
  margin-bottom: 6px;
  margin-top: 10px;
`;
const messageStyle = core_1.css `
  font-size: 16px;
  color: ${design_system_1.Colors.grey700};
`;
const buttonContainerStyle = core_1.css `
  padding-top: 20px;
`;
const waitingLabelStyle = core_1.css `
  margin-right: 10px;
`;
const waitingWrapperStyle = core_1.css `
  display: flex;
`;
const iconsContainerStyle = core_1.css `
  display: flex;
  align-items: center;
  justify-items: center;
  margin-bottom: 10px;
`;
const iconConnectorContainerStyle = core_1.css `
  padding: 0 ${theme_1.Spacing.small}px;
`;
const iconZapierContainerStyle = core_1.css `
  background-color: ${design_system_1.Colors.white};
  border-radius: 15px;
  border: 1px solid ${theme_1.Colors.theme.secondary.border};
  display: flex;
  padding: 10px;
`;
const webhookUrlStyle = core_1.css `
  font-family: monospace;
`;
function getMessage(props) {
    if (props.webhookUrl) {
        return (core_1.jsx(react_1.Fragment, null,
            "Send a request to this webhook URL:",
            ' ',
            core_1.jsx("span", { css: webhookUrlStyle }, props.webhookUrl),
            " then test your trigger."));
    }
    if (props.isTesting && props.directionsTestingMessage) {
        return props.directionsTestingMessage;
    }
    if (props.directionsMessage) {
        return props.directionsMessage;
    }
    return (core_1.jsx(react_1.Fragment, null,
        "We'll find a recent ",
        lodash_1.lowerCase(props.noun),
        " in your ",
        props.serviceName,
        ' ',
        "account",
        ' ',
        props.authTitle && (core_1.jsx(AuthBox_1.default, { api: props.serviceKey, authTitle: props.authTitle })),
        ' ',
        "to confirm that the right account is connected and your trigger is set up correctly."));
}
function TriggerTestingDirections(props) {
    const message = getMessage(props);
    const buttonContent = props.isTesting ? (core_1.jsx("span", { css: waitingWrapperStyle },
        core_1.jsx("span", { css: waitingLabelStyle }, "Testing"),
        " ",
        core_1.jsx(design_system_1.Spinner, { size: "small" }))) : (props.directionsButtonLabel || 'Test trigger');
    return (core_1.jsx("div", { css: rootStyle },
        core_1.jsx("div", { css: iconsContainerStyle },
            core_1.jsx(common_components_1.LogoImage, { app: props.serviceKey, backgroundType: "white", border: true, borderPadding: 10, borderRadius: 15, size: 40 }),
            core_1.jsx("div", { css: iconConnectorContainerStyle },
                core_1.jsx(design_system_1.Icon, { color: "grey700", name: "arrowBigRight", size: 16 })),
            core_1.jsx("div", { css: iconZapierContainerStyle },
                core_1.jsx(design_system_1.Icon, { color: "orange500", name: "zapierLogo", size: 40 }))),
        core_1.jsx("div", { css: headerStyle },
            core_1.jsx(design_system_1.Text, { tag: "p", type: "subtitle800" }, "Test your trigger")),
        core_1.jsx("div", { css: messageStyle }, message),
        core_1.jsx("div", { css: buttonContainerStyle },
            core_1.jsx(design_system_1.Button, { color: "blue", disabled: props.isTesting, hasShadow: !props.isTesting, id: "test-sample", onClick: props.onTest }, buttonContent))));
}
exports.default = TriggerTestingDirections;
